// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__rK23m","leftHalf":"styles_leftHalf__31zSV","rightHalf":"styles_rightHalf__3j_d1"};